import { ComponentProps } from 'react';
import SearchIcon from '@/shared/assets/search.svg?svg';
import clsx from 'clsx';

import styles from './SearchInput.module.css';

interface SearchInputProps extends ComponentProps<'input'> {
  iconPosition?: 'left' | 'right';
  variant?: 'default' | 'outline';
}

export const SearchInput = ({
  className,
  variant = 'default',
  iconPosition = 'left',
  ...props
}: SearchInputProps) => {
  return (
    <div className={clsx(styles.container, styles[variant], className)}>
      {iconPosition === 'left' && <SearchIcon />}
      <input {...props} />
      {iconPosition === 'right' && <SearchIcon />}
    </div>
  );
};
